<template>
  <b-container>
    <b-col class="text-left">
      <router-link :to="{ name: 'SiteInfo' }">
        <b-button pill variant="purple" class="ml-1 mb-1"
        > بازگشت به صفحه تنظیمات
        </b-button
        >
      </router-link>
    </b-col>

    <form @submit.prevent="onSubmit">

      <b-form-row v-if="isIcon">
        <b-col lg="12" class="mt-5 mb-5 ml-auto mr-auto">
          <form-group class="col text-center Font" :validations="$v.form.icon">
            <div slot-scope="{ errors, invalid }">
              <b-form-file
                  browse-text="انتخاب عکس"
                  @change="onFileChange"
                  class="text-center"
                  v-model="form.icon"
                  placeholder="انتخاب عکس"
                  drop-placeholder="انتخاب عکس">
              </b-form-file>

              <input id="icon-image" type="hidden" @change="onFileChange"/>

              <div id="preview" class="mt-2">
                <img alt="" v-if="form.preview" width="300" height="300" :src="form.preview"/>
              </div>

              <form-errors-manager :errors="errors"/>
            </div>
          </form-group>
        </b-col>
      </b-form-row>


      <b-form-row v-else-if="isOrderVerificationAccess">
        <b-col lg="12" class="mt-5 mb-5 ml-auto mr-auto">
          <select v-model="form.value" class="custom-select">
            <option value="">انتخاب کنید</option>
            <option v-for="(item,index) in orderVerificationAccess" :key="index" :value="index">{{ item }}</option>
          </select>
        </b-col>
      </b-form-row>


      <b-form-row v-else-if="isDashboardVerificationAccess">
        <b-col lg="12" class="mt-5 mb-5 ml-auto mr-auto">
          <select v-model="form.value" class="custom-select">
            <option value="">انتخاب کنید</option>
            <option v-for="(item,index) in dashboardVerificationAccess" :key="index" :value="index">{{ item }}</option>
          </select>
        </b-col>
      </b-form-row>

      <b-form-row v-else-if="isCartType">
        <b-col lg="12" class="mt-5 mb-5 ml-auto mr-auto">
          <select v-model="form.value" class="custom-select">
            <option value="">انتخاب کنید</option>
            <option v-for="(item,index) in cartType" :key="index" :value="index">{{ item }}</option>
          </select>
        </b-col>
      </b-form-row>

      <b-form-row v-else-if="isRegisterType">
        <b-col lg="12" class="mt-5 mb-5 ml-auto mr-auto">
          <select v-model="form.value" class="custom-select">
            <option value="">انتخاب کنید</option>
            <option v-for="(item,index) in registerType" :key="index" :value="index">{{ item }}</option>
          </select>
        </b-col>
      </b-form-row>


      <b-form-row v-else-if="isGateStatus">
        <b-col lg="12" class="mt-5 mb-5 ml-auto mr-auto">
          <select v-model="form.value" class="custom-select">
            <option value="">انتخاب کنید</option>
            <option v-for="(item,index) in gateStatus" :key="index" :value="index">{{ item }}</option>
          </select>
        </b-col>
      </b-form-row>


      <div class="row" v-else>
        <form-group v-if="$router.currentRoute.params.id === undefined || !isFreeCity" class="col-lg-6"
                    :validations="$v.form.name">
          <div slot-scope="{ errors, invalid }">
            <label>نام</label>
            <b-form-select v-model="form.name" :options="options" :disabled="editable"></b-form-select>
            <form-errors-manager :errors="errors"/>
          </div>
        </form-group>

        <div v-if="isFreeCity" class="col-lg-12 mt-2">
          <form-group class="col-lg-12 text-right " :validations="$v.form.province">
            <div slot-scope="{ errors, invalid }">

              <label>استان</label>
              <b-form-input v-model="form.province" debounce="400" autocomplete="off" @update="provinceSearch"
                            list="provinces-list"></b-form-input>

              <datalist id="provinces-list">
                <option v-for="province in provinces" :key="province.id" :value="province.name">{{
                    province.name
                  }}
                </option>
              </datalist>

              <form-errors-manager :errors="errors"/>
            </div>
          </form-group>

          <form-group v-if="isProvinceFill" class="col-lg-12 text-right mt-2 " :validations="$v.form.city">
            <div slot-scope="{ errors, invalid }">
              <label>شهر</label>
              <b-form-input v-model="form.city" debounce="400" @update="citySearch" autocomplete="off"
                            list="cities-list"></b-form-input>

              <datalist id="cities-list">
                <option v-for="city in cities" :key="city.id">{{ city.name }}</option>
              </datalist>

              <form-errors-manager :errors="errors"/>
            </div>
          </form-group>
        </div>

        <div v-if="isDefaultCity" class="col-lg-12 mt-2">
          <form-group class="col-lg-12 text-right " :validations="$v.form.province">
            <div slot-scope="{ errors, invalid }">

              <label>استان</label>
              <b-form-input v-model="form.province" debounce="400" autocomplete="off" @update="provinceSearch"
                            list="provinces-list"></b-form-input>

              <datalist id="provinces-list">
                <option v-for="province in provinces" :key="province.id" :value="province.name">{{
                    province.name
                  }}
                </option>
              </datalist>

              <form-errors-manager :errors="errors"/>
            </div>
          </form-group>

          <form-group v-if="isProvinceFill" class="col-lg-12 text-right mt-2 " :validations="$v.form.city">
            <div slot-scope="{ errors, invalid }">
              <label>شهر</label>
              <b-form-input v-model="form.city" debounce="400" @update="citySearch" autocomplete="off"
                            list="cities-list"></b-form-input>

              <datalist id="cities-list">
                <option v-for="city in cities" :key="city.id">{{ city.name }}</option>
              </datalist>

              <form-errors-manager :errors="errors"/>
            </div>
          </form-group>
        </div>

        <div v-if="isDefaultProvince" class="col-lg-12 mt-2">
          <form-group class="col-lg-12 text-right " :validations="$v.form.province">
            <div slot-scope="{ errors, invalid }">

              <label>استان</label>
              <b-form-input v-model="form.province" debounce="400" autocomplete="off" @update="provinceSearch"
                            list="provinces-list"></b-form-input>

              <datalist id="provinces-list">
                <option v-for="province in provinces" :key="province.id" :value="province.name">{{
                    province.name
                  }}
                </option>
              </datalist>

              <form-errors-manager :errors="errors"/>
            </div>
          </form-group>
        </div>


        <form-group v-if="!isFreeCity  &&  !isDefaultCity && !isDefaultProvince" class="col-lg-6" :validations="$v.form.value">
          <div slot-scope="{ errors, invalid }">
            <label>مقدار</label>
            <input v-model="form.value" type="text" class="form-control">
            <form-errors-manager :errors="errors"/>
          </div>
        </form-group>


      </div>


      <b-btn pill variant="purple" type="submit" class=" mt-2 w-100">
        ثبت
      </b-btn>
    </form>

  </b-container>
</template>

<script>
import {mapGetters, mapActions} from "vuex";
import FormGroup from "../../validator/FormGroup";
import {required, numeric, email, url, minLength, maxLength, helpers} from "vuelidate/lib/validators";
import {
  phone,
  telphone,
  phoneStartWith98
} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/VuelidateCustomValidatoins";
import {
  dashboardVerificationAccess,
  orderVerificationAccess,
  cartType,
  registerType,
} from "../SiteInfoVerificationOptions";

import FormErrorsManager from '../../validator/FormErrorsManager.vue'
import router from "@/router";
import {findObjects} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import {gateStatus} from '../GateStatus';

export default {
  name: "SiteInfoForm",
  components: {FormGroup, FormErrorsManager},
  data() {
    return {
      form: {
        id: '',
        name: '',
        value: '',
        preview: "",
        icon: [],
        free_city_delivery: '',
        province: '',
        city: '',
      },
      dashboardVerificationAccess,
      orderVerificationAccess,
      cartType,
      registerType,
      gateStatus,
    }
  },
  props: ['submitFunction', 'title', 'editable'],
  validations() {
    if (this.form.name === 'icon' || this.form.name === 'loadingIcon') {
      return {
        form: {
          icon: {required}
        }
      }
    } else if (this.form.name === 'free_city_delivery') {
      return {
        form: {
          province: {required},
          city: {required},
        }
      }
    } else if (this.form.name === 'default_province') {
      return {
        form: {
          province: {required},
        }
      }
    } else if (this.form.name === 'default_city') {
      return {
        form: {
          province: {required},
          city: {required},
        }
      }
    } else {
      return {
        form: {
          name: {required},
          value: this.getDynamicValidation(), // todo dynamic validation for each field
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      attributes: "SiteInfo/getAttributes",
      provinces: "Province/getProvinces",
      cities: "City/getCities"
    }),
    isProvinceFill() {
      return findObjects(this.$store.getters['Province/getProvinces'], this.form.province) != null
    },
    filtered() {
      if (this.editable == false) { // if its create
        return Object.entries(this.attributes).filter(function ([key, val], index) {
          return val.create == true;
        })
      }

      return Object.entries(this.attributes);
    },
    options() {
      return this.filtered.map(
          ([key, val], index) => ({value: key, text: val.fa})
      )
    },
    isIcon() {
      return (this.form.name === 'icon' || this.form.name === 'loadingIcon');
    },
    isFreeCity() {
      return (this.form.name == 'free_city_delivery')
    },
    isOrderVerificationAccess() {
      return (this.form.name === 'orderVerificationAccess')
    },
    isDashboardVerificationAccess() {
      return (this.form.name === 'dashboardVerificationAccess')
    },
    isCartType() {
      return (this.form.name === 'cartType')
    },
    isRegisterType() {
      return (this.form.name === 'registerType')
    },
    isDefaultProvince() {
      return (this.form.name == 'default_province')
    },
    isDefaultCity() {
      return (this.form.name == 'default_city')
    },
    isGateStatus() {
      return (this.form.name == 'gate_status')
    },
  },
  methods: {
    ...mapActions({
      'provinceSearch': "Province/search"
    }),
    citySearch(words) {
      let province = findObjects(this.$store.getters['Province/getProvinces'], this.form.province).id;
      this.$store.dispatch('City/search', {words, province});
    },
    invalid() {
      this.$v.$touch();
      return !this.$v.$invalid;
    },
    onSubmit() {
      if (this.invalid()) {
        let form = this.form


        if (this.form.name === 'free_city_delivery') {
          form.value = findObjects(this.$store.getters['City/getCities'], form.city).id;
        }

        // default_city

        if (this.form.name === 'default_province') {
          form.value = findObjects(this.$store.getters['Province/getProvinces'], form.province).id;
        }

        if (this.form.name === 'default_city') {
          form.value = findObjects(this.$store.getters['City/getCities'], form.city).id;
        }

        this.submitFunction(form)
      }
    },
    onFileChange(e) {
      const file = e.target.files[0];

      this.form.icon = file;
      this.form.preview = URL.createObjectURL(file);
    },
    getDynamicValidation() {
      switch (this.form.name) {
        case 'social_media_instagram':
        case 'social_media_pinterest':
        case 'social_media_twitter':
        case 'social_media_linkedin':
        case 'social_media_aparat':
        case 'social_media_telegram':
        case 'social_media_youtube':
        case 'host':
          return {required, url}
        case 'email':
          return {required, email}
        case 'cell_phone':
          return {required, phone}
        case 'social_media_whatsapp':
          return {required, minLength: minLength(13), maxLength: maxLength(13), phoneStartWith98}
        case 'tel_phone':
        case 'fax':
          return {required, telphone}

        case 'deliver_price':
        case 'deliver_free_if_price_bigger_than':
        case 'tax':
          return {required, numeric}
        default:
          return {required}
      }
    }
  },
  async mounted() {
    await this.$store.dispatch("SiteInfo/getSiteInfos")
    const siteInfoId = router.currentRoute.params.id

    if (siteInfoId !== undefined) {
      this.form.id = siteInfoId;
      const form = this.form
      this.$store.dispatch('SiteInfo/getSiteInfo', form).then(async res => {

        const siteInfo = res.data.data
        this.form.name = await siteInfo.name
        if (this.form.name === 'icon' || this.form.name === 'loadingIcon') {
          this.form.preview = await siteInfo.value
        } else if (this.form.name === 'free_city_delivery') {
          this.form.value = await siteInfo.value.id
          this.form.province = await siteInfo.value.province.name
          this.form.city = await siteInfo.value.name

          this.$store.dispatch('Province/search', form.province).then(res => {
            this.$store.dispatch('City/search', {words: form.city, province: siteInfo.value.province.id})
          })

        } else {
          this.form.value = await siteInfo.value
        }

      }).catch(err => {
        console.log(err)
        router.push({name: 'SiteInfo'})
      })
    }
  },
}

</script>

<style scoped></style>